<script>
import getLabel from 'foundation/js/getLabel'
import options from './HeroSectionCancerforum.options'
export default options
</script>

<template>
  <article
    class="kb-hero-section kb-hero-section--small-title kb-hero-section--centered-no-media"
  >
    <div class="kb-hero-section__background">
      <svg
        viewBox="0 0 1408 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation"
      >
        <path d="M0 40.1c466.42 56.39 938.34 72.971 1408 49.72V0H0v40.1Z" />
      </svg>
    </div>

    <div class="kb-hero-section__content-wrapper">
      <div class="kb-hero-section__content">
        <h1 class="kb-hero-general__content__title">{{ getLabel('title') }}</h1>

        <p class="kb-hero-general__content__text">{{ getLabel('text') }}</p>

        <div class="kb-hero-section__content__buttons">
          <button 
            :disabled="isSubmitting || isUserAwaitingAccess"
            @click="handleClick"
            class="kb-button kb-button--full-color-spot"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
    </div>
  </article>
</template>
